import VBadge from './VBadge.vue';

export { VBadge };
export default VBadge;
